export const formatToolCallStatus = (name?: string | null, args?: unknown): string | undefined => {
  if (!name) {
    return undefined;
  }

  const argObj = args && typeof args === 'object' ? (args as Record<string, unknown>) : null;

  const asString = (key: string): string | undefined => {
    const value = argObj?.[key];

    return typeof value === 'string' && value.length > 0 ? value : undefined;
  };

  switch (name) {
    case 'search_documents':
      return `Ищу документы ${asString('query') ? `: «${asString('query')}»` : ''}`;
    case 'search_news':
      return `Ищу новости ${asString('query') ? `: «${asString('query')}»` : ''}`;
    case 'search_insights':
      return `Собираю инсайты ${asString('query') ? `: «${asString('query')}»` : ''}`;
    case 'get_recent_documents':
      return 'Получаю недавние документы';
    case 'get_document_pages':
      return `Читаю страницы документа${asString('document_id') ? ` ${asString('document_id')}` : ''}`;
    default:
      return `Выполняю ${name}`;
  }
};
